import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { TObject } from '../../../../infrastructure/type-extensions';
import { observer } from 'mobx-react';
import { FormField } from '../form-field/form-field';
import { CopyButton } from '../../copy-button/copy-button';
import { FormFieldError } from './form-field-error';
import React from 'react';
import { FormFieldProps } from '../../../../infrastructure/form-viewmodel-controller';
import { REQUIRED_FIELD_TEXT } from '../../../../constants/common-labels.constants';

interface IProps {
    field: FormFieldProps;
    labelDescriptor: MessageDescriptor;
    withError?: boolean;
    fieldMessageValues?: TObject<string>;
    withCopyBtn?: boolean;
    rows?: number;
    infoText?: string | JSX.Element;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
}

interface InputProps {
    field: FormFieldProps;
    rows: number;
    disabled?: boolean;
    readOnly?: boolean;
}

const Textarea = ({ field, rows, disabled, readOnly }: InputProps): JSX.Element => (
    <textarea
        rows={rows}
        style={{ resize: 'vertical' }}
        className='oe-form-field__control'
        value={field.value as string}
        onChange={e => field.setValue(e.target.value)}
        onBlur={field.setTouched}
        disabled={disabled}
        readOnly={readOnly}
    />
);

export const FormFieldInputTextArea = observer(({
    field,
    labelDescriptor,
    rows = 3,
    fieldMessageValues,
    withError,
    withCopyBtn,
    infoText,
    disabled,
    readOnly,
    required
}: IProps): JSX.Element => {
    return (
        <FormField
            className='m-bottom-20px'
            label={<>
                <FormattedMessage values={fieldMessageValues} {...labelDescriptor} />
                {required && <span className='oe-form-field__title-required'><FormattedMessage {...REQUIRED_FIELD_TEXT} /></span>}
            </>}
        >
            {
                withCopyBtn
                    ? (
                        <div className='flex'>
                            <Textarea field={field} rows={rows} disabled={disabled} readOnly={readOnly} />
                            <CopyButton copyValue={field.value} className='m-left-10px' disabled={!field.value} />
                        </div>
                    )
                    : <Textarea field={field} rows={rows} disabled={disabled} readOnly={readOnly} />
            }
            {infoText && <p className='oe-form-field__info m-top-0px m-bottom-0px'>{infoText}</p>}
            {withError && <FormFieldError field={field} labelDescriptor={labelDescriptor} />}
        </FormField>
    );
});
